import type { MsgDeskPageProps } from '../../MsgDeskApp'
import { EmailMainMessageView } from '../../components/email/EmailMessageView'

/**
 * Email entities are immutable transport records. This surface deliberately
 * mounts no editor provider, editor template, reply composer, or edit action.
 */
export function EmailRoutedPage(_props: MsgDeskPageProps) {
  return <EmailMainMessageView />
}
